/* YMM V3: home-fill v4 — Section Rendering top-up.

   Strategy:
   - Each featured-collection section emits  <div data-ymm-fill="{collection.url}">
     and wraps its <ul data-ymm-home-grid> grid inside.
   - When YMM is applied, fetch each section's collection URL with the filter
     applied (?filter.p.m.custom.fitment_model={code}), parse the response,
     and replace the home grid with the first N matching cards (where N = the
     count of originally-rendered cards, i.e. the team's products_to_show).
   - When YMM is reset, restore each grid to its originally-rendered HTML.
   - When the filter returns 0 cards, restore the original (lenient fallback —
     no empty sections).

   Notes:
   - Year is not used in the filter URL (Shopify metafield filters can't express
     "min_year ≤ Y ≤ max_year" directly). Model fitment is the primary cue.
   - Per-page fetches are de-duplicated by URL via the `inflight` map.
   - Original grid HTML is cached on first apply (per wrapper, via WeakMap).
*/
(function () {
  var KEY = 'ymm.selection.v11';

  var ALIAS = {
    jeep_wrangler_yj: 'yj', wrangler_yj: 'yj',
    jeep_wrangler_tj: 'tj', wrangler_tj: 'tj',
    jeep_wrangler_jk_2dr: 'jk_2dr', wrangler_jk_2dr: 'jk_2dr',
    jeep_wrangler_jku_4dr: 'jk_4dr', wrangler_jk_unlimited_4dr: 'jk_4dr',
    jeep_wrangler_jl_2dr: 'jl_2dr', wrangler_jl_2dr: 'jl_2dr',
    jeep_wrangler_jlu_4dr: 'jl_4dr', wrangler_jl_unlimited_4dr: 'jl_4dr',
    jeep_gladiator_jt: 'jt', gladiator_jt: 'jt',
    other_offroad: 'other'
  };

  function canon(v) {
    v = String(v == null ? '' : v).trim().toLowerCase();
    return ALIAS[v] || v;
  }
  function readSel() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || '{}') || {};
      s.model = canon(s.model || '');
      return s;
    } catch (e) { return {}; }
  }
  function active(s) { return !!(s && s.model); }

  /* ---- caching original grid HTML per wrapper, so reset can restore it ---- */
  var originalHTML = new WeakMap();
  function cacheOriginal(wrapper, grid) {
    if (originalHTML.has(wrapper)) return;
    originalHTML.set(wrapper, grid.innerHTML);
  }
  function restoreOriginal(wrapper, grid) {
    var orig = originalHTML.get(wrapper);
    if (orig != null) grid.innerHTML = orig;
  }
  function findGrid(wrapper) { return wrapper.querySelector('[data-ymm-home-grid]'); }
  function countOriginalCards(wrapper) {
    var orig = originalHTML.get(wrapper);
    if (orig == null) return 0;
    var temp = document.createElement('div');
    temp.innerHTML = orig;
    return temp.querySelectorAll(':scope > li, li').length;
  }

  /* ---- extracting product cards from a fetched collection page ---- */
  function extractCards(html) {
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); }
    catch (e) { return []; }
    var selectors = [
      '#product-grid > li',
      'ul#product-grid > li',
      'ul.product-grid > li',
      'ul[data-ymm-home-grid] > li',
      '.collection ul.grid > li',
      'ul.grid.product-grid > li'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var found = doc.querySelectorAll(selectors[i]);
      if (found.length) return Array.prototype.slice.call(found);
    }
    return [];
  }

  /* ---- one fetch per URL, shared across wrappers if they happen to match ---- */
  var inflight = {};
  function fetchFiltered(url) {
    if (inflight[url]) return inflight[url];
    inflight[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
    return inflight[url];
  }

  function topUpOne(wrapper, model) {
    var url = wrapper.getAttribute('data-ymm-fill');
    /* data-ymm-fill may be the collection URL, or in legacy themes may be 'true'/'1'.
       Only proceed when it's a path. */
    if (!url || url === 'true' || url === '1' || url.charAt(0) !== '/') return;
    var grid = findGrid(wrapper);
    if (!grid) return;

    cacheOriginal(wrapper, grid);
    var N = countOriginalCards(wrapper);
    if (N === 0) N = 4;

    var filteredUrl = url +
      (url.indexOf('?') >= 0 ? '&' : '?') +
      'filter.p.m.custom.fitment_model=' + encodeURIComponent(model);

    fetchFiltered(filteredUrl).then(function (html) {
      if (!html) { restoreOriginal(wrapper, grid); return; }
      var cards = extractCards(html);
      if (!cards.length) { restoreOriginal(wrapper, grid); return; }
      var toShow = cards.slice(0, N);
      grid.innerHTML = '';
      toShow.forEach(function (li) { grid.appendChild(li.cloneNode(true)); });
    });
  }

  function restoreAll() {
    document.querySelectorAll('[data-ymm-fill]').forEach(function (w) {
      var g = findGrid(w);
      if (g) restoreOriginal(w, g);
    });
  }

  var lastKey = null;
  function applyAll() {
    var sel = readSel();
    if (!active(sel)) {
      restoreAll();
      lastKey = null;
      return;
    }
    if (sel.model === lastKey) return;
    lastKey = sel.model;
    document.querySelectorAll('[data-ymm-fill]').forEach(function (wrapper) {
      topUpOne(wrapper, sel.model);
    });
  }
  function invalidate() { lastKey = null; inflight = {}; applyAll(); }

  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('load', applyAll);
  window.addEventListener('ymm:changed', invalidate);
  document.addEventListener('ymm:applied', invalidate);
  window.addEventListener('ymm:reset', function () { restoreAll(); lastKey = null; });

  window.YMM_HOME_FILL = { apply: invalidate, restore: restoreAll };
})();
